import React, { useRef, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { isAfter } from 'date-fns'
import { toast } from 'components/Shared/Toast'
import clsx from 'clsx'

import { parseDate } from 'utils'
import { useEditorState, useEditorActions } from '../../editor-context'
import { Modal, ModalBody, ModalHeader, FormGroup } from 'reactstrap';


export function Changelog() {
  const { t } = useTranslation()
  const { document: doc, originalDocument } = useEditorState()
  const { compareWordOnlineVersion } = useEditorActions()
  const [compareState, setCompareState] = useState(null);
  const [isComparing, setIsComparing] = useState(false);
  const version1Ref = useRef()
  const version2Ref = useRef()

  const { versions = [] } = doc.wordonline || {}
  const { Version } = originalDocument.wordonline || {}

  const versionOptions = useMemo(() => {
    return versions.filter(v => v.type !== 'compare-version').map(version =>
      <option key={version._id} value={version._id}>{version.user}{version.user && ' - '}{parseDate(version.modified)}</option>
    )
  }, [versions])

  const handleCompare = () => {
    setIsComparing(true);
    const version1 = version1Ref.current.value;
    const version2 = version2Ref.current.value;

    if (version1 === version2) {
      toast.error('Para comparar el documento, las versiones tienen que ser diferentes entre si.');
    } else if (version1 && version2 && version1 !== '' && version2 !== '') {
      compareWordOnlineVersion({
        version1,
        version2
      }, {
        onSuccess: (data) => {
          setCompareState({ leftPdf: data.actualVersion, rightPdf: data.diff })
        },
        onSettled: () => {
          setIsComparing(false)
        },
      })
      // app.request('modals').destroyAll();
      // app.request('modals').show(new ComparePDF({ model: this.model, leftPdf: res.actualVersion, rightPdf: res.diff }))
    }
  }

  return (
    <div className="sidebar-content">
      <div className="text-center p-2">
        <strong>{t('contracts.negotiation.approvals')}</strong>
        <p>
          {t('contracts.negotiation.visualize')}
        </p>
      </div>
      <FormGroup className="text-center">
            <ChangelogContainer versions={versions} currentVersion={Version} contract={doc} />
      </FormGroup>
      <div className="p-3">
        <strong>{t('contracts.negotiation.markup')}</strong>
        <p>
          {t('contracts.negotiation.compare')}
        </p>
        <FormGroup>
          <label>{t('contracts.negotiation.compareBtn')}:</label>
          <select name="version1" className="form-control input-sm" required="" ref={version1Ref}>
            {versionOptions}
          </select>
        </FormGroup>
        <FormGroup>
          <label>{t('contracts.negotiation.with')}:</label>
          <select name="version2" className="form-control input-sm" required="" ref={version2Ref}>
            {versionOptions}
          </select>
        </FormGroup>
        <button className="btn btn-primary btn-sm w-100" type="button" data-action="end-changelog" onClick={handleCompare} title={t('contracts.negotiation.generate_versioned')}>
          <i className="fas fa-exchange"></i> {isComparing ? t('Comparando...') : t('contracts.negotiation.compareBtn')}
        </button>
      </div>
      
      <ComparePDF {...compareState} isOpen={!!compareState} onClose={() => setCompareState(null)} />
    </div>
  )
}

function ChangelogContainer({ versions, currentVersion, contract }) {
  const [selectedVersion, setSelectedVersion] = useState(currentVersion)
  const { setPreviewOnly, changeWordPreviewDocument } = useEditorActions()

  const sortedVersions = useMemo(() => {
    return [...versions].sort(v => isAfter(new Date(v.modified), new Date(v.modified)) ? 1 : -1)
  }, [versions])

  const handlePreview = (version) => {
    setSelectedVersion(version.versionId)
    changeWordPreviewDocument({ versionId: version.versionId })
    setPreviewOnly({ isPreviewOnly: version.versionId !== currentVersion })

  }


  return (
    <div className="clause-container">
      {
        sortedVersions.map((version) => (
          <ChangelogItem
            version={version}
            isCurrent={version.versionId === currentVersion}
            isSelected={version.versionId === selectedVersion}
            onPreview={handlePreview}
            contract={contract}
          />
        ))
      }
    </div>
  )
}

function ChangelogItem({ version, isCurrent, isSelected, contract, onPreview }) {

  const { t } = useTranslation()
  const [isOpen, setIsOpen] = useState(false);

  const participantsIdentities = useMemo(() => {
    return contract.participants.reduce((obj, participant) => {
      obj[participant._id] = participant.obligation === 'individual' ? `${participant.name} ${participant.last_name || ''}` : participant.name;

      // if (!version.accepted.includes(participant._id) && !version.rejected.includes(participant._id)) {
      //   if (isCurrent) version.review.push(participant._id);
      //   else version.rejected.push(participant._id);
      // }

      return obj
    }, {})


  }, [contract.participants])

  const toggle = () => setIsOpen(open => !open)

  const handlePreview = (evt) => {
    evt.stopPropagation();
    onPreview(version)
  }

  return (
    <div>
      <div className="clause-head border pointer rounded mt-1">
        <div className="mt-2">
          <span onClick={toggle}>
            <p className="font-weight-bold">
              {t('contracts.negotiation.version')}: {isCurrent ? t('contracts.negotiation.current') : version.versionNumber + 1}
            </p>
            <p>
              {version.user && <>{t('contracts.negotiation.autor')}: {version.user}</>}
            </p>
            <p className="font-weight-bold">
              {parseDate(version.modified)} <a href="#" onClick={handlePreview} data-action="preview-version" className={clsx('text-dark hover-none', isSelected && 'd-none')}><i className="fas fa-eye"></i></a>
            </p>
          </span>
        </div>
      </div>
      { contract.status === '' &&
        <div
          className={clsx('pointer clause-list-container-accepted', isCurrent && 'in', !isOpen && 'collapse')}
          aria-expanded={isCurrent ? 'true' : 'false'}
          id={`collapse-${version._id}`}
        >
          <div className="clause-list mb-4">
            <div className="clause-item-container">
              <div className="clause-item rounded  ml-4 mb-3">
                <div className="clean-text bold-text p-0 mb-4">
                </div>
                {version.accepted?.map(participantId => (
                  <div className="p-2 py-0">
                    <div className="version-acceptance rounded mb-2">
                      <div className="version-name">
                        <span className="initials font-weight-bold">{participantsIdentities[participantId]}</span>
                      </div>
                      <div className="version-status">
                        <span className="labels"><i className="fas fa-circle text-success"></i>{t('sign.contract.accepted')}</span>
                      </div>
                    </div>
                  </div>
                ))}
                {version.rejected?.map(participantId => (
                  <div className="p-2 py-0">
                    <div className="version-acceptance rounded mb-2">
                      <div className="version-name">
                        <span className="initials font-weight-bold">{participantsIdentities[participantId]}</span>
                      </div>
                      <div className="version-status">
                        <span className="labels"><i className="fas fa-circle text-danger"></i>{t('sign.contract.rejected')}</span>
                      </div>
                    </div>
                  </div>
                ))}
                {version.review?.map(participantId => (
                  <div className="p-2 py-0">
                    <div className="version-acceptance rounded mb-2">
                      <div className="version-name">
                        <span className="initials font-weight-bold">{participantsIdentities[participantId]}</span>
                      </div>
                      <div className="version-status">
                        <span className="labels"><i className="fas fa-circle text-warning"></i>{t('sign.contract.review')}</span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  )
}

function ComparePDF({ isOpen, leftPdf, rightPdf, onClose }) {

  const { t } = useTranslation();

  return (
    <Modal size="lg" centered isOpen={isOpen}>
      <ModalHeader toggle={onClose}>
        {t('contracts.negotiation.compare_versions')}
      </ModalHeader>
      <ModalBody className="row">
        <div className="col-sm-6 text-muted text-center">
          <h4><strong>{t('contracts.negotiation.current_version')}</strong></h4>
          <div id="leftPdf" className='iframe-container'>
            <iframe src={`${leftPdf}#zoom=FitH`} width="100%" height="600px" seamless fraemeBorder="0" />
          </div>
        </div>
        <div className="col-sm-6 text-muted text-center">
          <h4><strong>{t('contracts.negotiation.changes')}</strong></h4>
          <iframe id="rightPdf" src={`${rightPdf}#zoom=FitH`} width="100%" height="600px" seamless fraemeBorder="0" />
        </div>
      </ModalBody>
    </Modal>
  );
}